import { useState } from "react";
import { message } from "antd";
import { ModalPortal } from "../../../../../common/components/modalPortal/modalPortal";
import { RecruiterGoals } from "../../../../../redux/models/recruiterGoals";
import { EditGoalsModal } from "./editGoalsModal";
import { EditIconButton } from "../../../../../common/components/iconButton/editIconButton";

export const EditGoalsButton = ({ goal, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const availableClients = goal
    ? [{ label: goal.clientName, value: goal.clientId }]
    : [];

  const onFinish = (closeModal) => async (values) => {
    try {
      setLoading(true);
      const res = await RecruiterGoals.update(goal.id, values, false);

      onSuccess(res.data);
      closeModal();
      message.success("Recruiter goals successfully updated");
    } catch (e) {
      message.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalPortal
      renderTrigger={(triggerProps) => (
        <EditIconButton disabled={loading} {...triggerProps}>
          Edit
        </EditIconButton>
      )}
    >
      {({ open, closeModal }) => (
        <EditGoalsModal
          open={open}
          loading={loading}
          onFinish={onFinish(closeModal)}
          availableClients={availableClients}
          goal={goal}
          closeModal={closeModal}
        />
      )}
    </ModalPortal>
  );
};
